import { useEffect, useEffectEvent, useState } from 'react'
import { listSpawns } from '../application/list-spawns'
import { workItems$ } from '../store'
import { workItems as workItemsPort, notify } from '../wiring'

// Loads spawns for a parent work item and merges them into the global workItems
// store so board cards and detail views share the same data layer.
const useSpawns = (parentId: string | null) => {
	const [loaded, setLoaded] = useState(false)

	const load = useEffectEvent(async (id: string) => {
		const result = await listSpawns(workItemsPort, id, notify)
		const current = workItems$.get()
		const existingIds = new Set(current.map(w => w.id))
		const newItems = result.filter(r => !existingIds.has(r.id))
		if (newItems.length > 0) {
			workItems$.set([...current, ...newItems])
		}
		setLoaded(true)
	})

	useEffect(() => {
		if (!parentId) {
			setLoaded(false)
			return
		}
		load(parentId)
	}, [parentId])

	return { loaded }
}

export { useSpawns }
